import React, { useState } from 'react';
import styles from './Block.module.css';

interface AnchorLinkIconProps {
  href: string;
}

const AnchorLinkIcon: React.FC<AnchorLinkIconProps> = (props) => {
  const [linkCopied, setLinkCopied] = useState(false);

  return (
    <span className={styles.anchorCopyLinkWrapper} contentEditable={false}>
      <a
        className={styles.anchorCopyLink}
        aria-label="Copy link to heading"
        href={props.href}
        onClick={(e) => {
          e.preventDefault();

          try {
            navigator.clipboard.writeText(e.currentTarget.href);
            setLinkCopied(true);
          } catch (e) {
            console.error(e);
          }
        }}
      />
      <aha-tooltip
        click-show
        click-hide={null}
        hover-show={false}
        // Slate will override the `textContent` of this node when serializing to HTML for copy operations
        data-slate-zero-width="z"
      >
        {linkCopied ? 'Link copied to clipboard' : 'Copy link to heading'}
      </aha-tooltip>
    </span>
  );
};

export default AnchorLinkIcon;
